import { Build, Lock } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getOpenSettingDialog, handleOpenSettingDialog } from "../../../reducers/uiSlice";
import UniDialog from "../../Common/UniDialog";
import Settings from "../../Settings";
import SecuritySettings from "../../Settings/SecuritySettings";
import SystemSettings from "../../Settings/SystemSettings";

const settingsConfig = [
    {
        id: 1,
        icon: <Build />,
        primary: "system",
        secondary: null,
        access_level: null,
        content: <SystemSettings />
    },
    {
        id: 2,
        icon: <Lock />,
        primary: "security",
        secondary: null,
        access_level: null,
        content: <SecuritySettings />
    }
]

function SettingsModal(props){

    const {t} = useTranslation('common')
    const dispatch = useDispatch();
    let openSettingDialog = useSelector(getOpenSettingDialog);

    return (
        <UniDialog
            title={t('settings')}
            maxWidth='sm'
            fullWidth
            open={openSettingDialog}
            onClose={()=>dispatch(handleOpenSettingDialog(false))}
            disableDefaultButtons
        >
            <Settings configs={settingsConfig}/>
        </UniDialog>
    )
}

export default SettingsModal